import { Observable } from 'rxjs/Rx'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { deliveriesRides, refreshRides } from '../services/delivery'
import { modify as patchRide } from '../services/ride'
import { alertSuccess, alertErrorDefault } from 'store/ducks/alert'
import { companyCourierGeolocation } from '../services/companyCourier'
import { intl } from 'i18n'
import { create } from 'store/services/messenger'

export const RIDES_REQUEST = 'deliveryRides/RIDES_REQUEST'
export const RIDES_SUCCESS = 'deliveryRides/RIDES_SUCCESS'
export const RIDES_FAILURE = 'deliveryRides/RIDES_FAILURE'
export const RIDES_REFRESH_REQUEST = 'deliveryRides/RIDES_REFRESH_REQUEST'
export const RIDES_REFRESH_SUCCESS = 'deliveryRides/RIDES_REFRESH_SUCCESS'
export const RIDES_REFRESH_FAILURE = 'deliveryRides/RIDES_REFRESH_FAILURE'
export const RIDE_PATCH_ADDRESS_REQUEST = 'deliveryRides/RIDE_PATCH_ADDRESS_REQUEST'
export const RIDE_PATCH_ADDRESS_SUCCESS = 'deliveryRides/RIDE_PATCH_ADDRESS_SUCCESS'
export const RIDE_PATCH_ADDRESS_FAILURE = 'deliveryRides/RIDE_PATCH_ADDRESS_FAILURE'
export const RIDE_COURIER_POSITION_UPDATE_REQUEST = 'deliveryRides/RIDE_COURIER_POSITION_UPDATE_REQUEST'
export const RIDE_COURIER_POSITION_UPDATE_SUCCESS = 'deliveryRides/RIDE_COURIER_POSITION_UPDATE_SUCCESS'
export const RIDE_COURIER_POSITION_UPDATE_FAILURE = 'deliveryRides/RIDE_COURIER_POSITION_UPDATE_FAILURE'
export const RIDE_CREATE_THREAD = 'deliveryRides/RIDE_CREATE_THREAD'
export const RIDE_CREATE_THREAD_SUCCESS = 'deliveryRides/RIDE_CREATE_THREAD_SUCCESS'
export const RIDE_CREATE_THREAD_SUCCESS_END = 'deliveryRides/RIDE_CREATE_THREAD_SUCCESS_END'
export const RIDE_CREATE_THREAD_FAILURE = 'deliveryRides/RIDE_CREATE_THREAD_FAILURE'

const INITIAL_STATE = {
  rides: [],
  currentRide: null,
  isThreadCreated: false,
  isLoading: false,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case RIDES_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case RIDES_SUCCESS:
      return {
        ...state,
        rides: action.payload,
        isLoading: false,
      }
    case RIDES_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case RIDES_REFRESH_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case RIDES_REFRESH_SUCCESS:
      return {
        ...state,
        rides: action.payload,
        isLoading: false,
      }
    case RIDES_REFRESH_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case RIDE_COURIER_POSITION_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case RIDE_COURIER_POSITION_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case RIDE_COURIER_POSITION_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case RIDE_CREATE_THREAD:
      return {
        ...state,
        isLoading: true,
        isThreadCreated: false,
      }
    case RIDE_CREATE_THREAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isThreadCreated: true,
      }
    case RIDE_CREATE_THREAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isThreadCreated: false,
      }
    case RIDE_CREATE_THREAD_SUCCESS_END:
      return {
        ...state,
        isLoading: false,
        isThreadCreated: false,
      }

    default:
      return state
  }
}

export const ridesRequest = (id) => ({
  type: RIDES_REQUEST,
  id,
})

export const ridesSuccess = (payload) => ({
  type: RIDES_SUCCESS,
  payload,
})

export const ridesFailure = (errors) => ({
  type: RIDES_FAILURE,
  errors,
})

export const ridesRefreshRequest = (id) => ({
  type: RIDES_REFRESH_REQUEST,
  id,
})

export const ridesRefreshSuccess = (payload) => ({
  type: RIDES_REFRESH_SUCCESS,
  payload,
})

export const ridesRefreshFailure = () => ({
  type: RIDES_REFRESH_FAILURE,
})

export const patchRideAddressRequest = (id, payload) => ({
  type: RIDE_PATCH_ADDRESS_REQUEST,
  id,
  payload,
})

export const patchRideAddressSuccess = () => ({
  type: RIDE_PATCH_ADDRESS_SUCCESS,
})

export const patchRideAddressFailure = () => ({
  type: RIDE_PATCH_ADDRESS_FAILURE,
})

export const postCourierPositionUpdateRquest = (id) => ({
  type: RIDE_COURIER_POSITION_UPDATE_REQUEST,
  id,
})

export const postCourierPositionSucces = () => ({
  type: RIDE_COURIER_POSITION_UPDATE_SUCCESS,
})

export const postCourierPositionFailure = () => ({
  type: RIDE_COURIER_POSITION_UPDATE_FAILURE,
})

export const createRideThread = (payload) => ({
  type: RIDE_CREATE_THREAD,
  payload,
})

export const createRideThreadSucess = () => ({
  type: RIDE_CREATE_THREAD_SUCCESS,
})

export const createRideThreadFailure = () => ({
  type: RIDE_CREATE_THREAD_FAILURE,
})

export const createRideThreadSuccessEnd = () => ({
  type: RIDE_CREATE_THREAD_SUCCESS_END,
})

export const epic = combineEpics(
  deliveriesRidesRequestEpic,
  deliveriesRidesRefreshRequestEpic,
  deliveriesRidesPatchAddressRequestEpic,
  deliveriesCourierPositionUpdateRequestEpic,
  deliveriesRidesCreateThreadRequestEpic,
  deliveriesRidesCreateThreadSuccesEndEpic,
)

export function deliveriesRidesRequestEpic(action$) {
  return action$.ofType(RIDES_REQUEST).mergeMap((action) =>
    Observable.ajax(deliveriesRides({ params: { id: action.id } }))
      .mergeMap((res) => Observable.of(ridesSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(ridesFailure())
      }),
  )
}

export function deliveriesRidesRefreshRequestEpic(action$) {
  return action$.ofType(RIDES_REFRESH_REQUEST).mergeMap((action) =>
    Observable.ajax(refreshRides({ params: { id: action.id } }))
      .map((res) => ridesRefreshSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(alertErrorDefault(), ridesRefreshFailure())
      }),
  )
}

export function deliveriesRidesPatchAddressRequestEpic(action$) {
  return action$.ofType(RIDE_PATCH_ADDRESS_REQUEST).mergeMap((action) =>
    Observable.ajax(patchRide({ params: { id: action.id }, payload: action.payload }))
      .mergeMap((res) =>
        Observable.of(
          patchRideAddressSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.ride.update.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(alertErrorDefault(), patchRideAddressFailure())
      }),
  )
}

export function deliveriesCourierPositionUpdateRequestEpic(action$) {
  return action$.ofType(RIDE_COURIER_POSITION_UPDATE_REQUEST).mergeMap((action) =>
    Observable.ajax(companyCourierGeolocation({ params: { id: action.id } }))
      .mergeMap((res) =>
        Observable.of(
          postCourierPositionSucces(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.ride.courrierPositionUpdate.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(alertErrorDefault(), postCourierPositionFailure())
      }),
  )
}

export function deliveriesRidesCreateThreadRequestEpic(action$) {
  return action$.ofType(RIDE_CREATE_THREAD).mergeMap((action) =>
    Observable.ajax(create({ payload: action.payload }))
      .mergeMap((res) => Observable.of(createRideThreadSucess(res.response)))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(alertErrorDefault(), createRideThreadFailure())
      }),
  )
}

export function deliveriesRidesCreateThreadSuccesEndEpic(action$) {
  return action$.ofType(RIDE_CREATE_THREAD_SUCCESS).mergeMap((action) => Observable.of(createRideThreadSuccessEnd()))
}
